import React from "react";

const NewsHero = ({ news }) => {
  return (
    <section className="pt-28 lg:pt-32 pb-8 bg-gradient-to-br from-[#F8FAFC] via-white to-[#FFF8F5]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-10">

        {/* Heading */}
        <div className="max-w-6xl mx-auto text-center">

          {/* Badge */}
          <span className="inline-flex items-center rounded-full border border-[#E94907]/20 bg-[#E94907]/10 px-4 py-2 text-xs md:text-sm font-semibold tracking-wider uppercase text-[#E94907]">
            Datoula Insights
          </span>

          {/* Title */}
          <h1 className="mt-5 text-xl sm:text-2xl md:text-3xl lg:text-[40px] font-bold leading-tight text-[#172554]">
            {news.title}
          </h1>

        </div>

        {/* Banner Image */}
        <div className="mt-10 overflow-hidden rounded-3xl border border-gray-200 shadow-sm">

          <img
            src={news.bannerImage}
            alt={news.title}
            className="
              w-full
              h-[220px]
              sm:h-[300px]
              md:h-[380px]
              lg:h-[430px]
              object-cover
              transition-transform
              duration-700
            "
          />

        </div>
      </div>
    </section>
  );
};

export default NewsHero;